import { Paper, Stack } from "@mui/material";
import React from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useAuthUser } from "react-auth-kit";
import {
  ChangePassword,
  UpdateCurrentUser,
} from "../../components/SecurityComponents";

function Security(props) {
  const authUser = useAuthUser();

  return (
    <main
      style={{
        width: "100%",
      }}
    >
      <PageTitle title="Security" />
      <Stack direction={"row"} gap={4}>
        <ChangePassword />
        <UpdateCurrentUser />
      </Stack>
    </main>
  );
}

export default Security;
